var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgCplusplus = function SvgCplusplus(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00599c",
    d: "M18.794 15c.139-.242.226-.514.226-.758V5.758c0-.244-.087-.517-.226-.758l-8.66 5 8.66 5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#004482",
    d: "m10.907 19.817 7.347-4.242c.212-.122.404-.333.543-.575l-8.66-5-8.66 5c.139.242.332.453.543.575l7.347 4.242c.423.244 1.116.244 1.539 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#659ad2",
    d: "M18.797 5a1.57 1.57 0 0 0-.543-.575L10.907.183c-.423-.244-1.116-.244-1.539 0L2.021 4.425c-.423.244-.77.844-.77 1.333v8.484c0 .244.087.517.226.758L18.798 5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.136 15.924c-3.267 0-5.924-2.658-5.924-5.924s2.658-5.924 5.924-5.924a5.944 5.944 0 0 1 5.13 2.96L12.702 8.52a2.974 2.974 0 0 0-2.566-1.482c-1.633 0-2.962 1.329-2.962 2.962s1.329 2.962 2.962 2.962a2.976 2.976 0 0 0 2.567-1.482l2.564 1.484a5.947 5.947 0 0 1-5.13 2.961z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.062 9.671h-.658v-.658h-.658v.658h-.658v.658h.658v.658h.658v-.658h.658v-.658zM18.53 9.671h-.658v-.658h-.658v.658h-.658v.658h.658v.658h.658v-.658h.658v-.658z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCplusplus);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;